export default {
    InvoiceStatus: {
        All: 'Tất cả',
        Valid: 'Hợp lệ',
        Invalid: 'Không hợp lệ',
        WaitChecking: 'Đang kiểm tra',
        InvoiceDraft: 'Bản nháp',
        NoHasPdf: 'Không có bản thể hiện',
        NoHasXml: 'Không có XML',
        Viewed: 'Đã xem',
        UnViewed: 'Chưa xem',
        Risky: 'Rủi ro',
        NoRisky: 'Không rủi ro',
        NotNeedCheck: 'Không kiểm tra'
    },
    OutInvoiceStatus: {
        All: 'Tất cả',
        HasXml: 'Có XML',
        NoHasXml: 'Không có XML'
    },
    Role: {
        Admin: 'Quản lý',
        User: 'Nhân viên'
    },
    TypeOfMoney: {
        VND: 'VND',
        USD: 'USD'
    },
    Month: {
        Month1: 'Tháng 1',
        Month2: 'Tháng 2',
        Month3: 'Tháng 3',
        Month4: 'Tháng 4',
        Month5: 'Tháng 5',
        Month6: 'Tháng 6',
        Month7: 'Tháng 7',
        Month8: 'Tháng 8',
        Month9: 'Tháng 9',
        Month10: 'Tháng 10',
        Month11: 'Tháng 11',
        Month12: 'Tháng 12'
    },
    Quarter: {
        Quarter1: 'Quý I',
        Quarter2: 'Quý II',
        Quarter3: 'Quý III',
        Quarter4: 'Quý VI'
    },
    Period: {
        ThisDay: 'Hôm nay',
        ThisWeek: 'Tuần này',
        FirstWeekToPresent: 'Đầu tuần tới hiện tại',
        ThisMonth: 'Tháng này',
        Last30Days: '30 ngày gần nhất',
        FirstMonthToPresent: 'Đầu tháng đến hiện tại',
        ThisQuarter: 'Quý này',
        FirstQuarterToPresent: 'Đầu quý đến hiện tại',
        ThisYear: 'Năm nay',
        FirstYearToPresent: 'Đầu năm đến hiện tại',
        SixFirstMonth: 'Sáu tháng đầu năm',
        SixLastMonth: 'Sáu tháng cuối năm',
        //Các tháng trong năm
        January: 'Tháng 1',
        February: 'Tháng 2',
        March: 'Tháng 3',
        April: 'Tháng 4',
        May: 'Tháng 5',
        June: 'Tháng 6',
        July: 'Tháng 7',
        August: 'Tháng 8',
        September: 'Tháng 9',
        October: 'Tháng 10',
        November: 'Tháng 11',
        December: 'Tháng 12',

        //Quý (DNThang sửa từ ký tự La mã về thành số nguyên)
        FiscalI: 'Quý 1', //Qúy 1
        FiscalII: 'Quý 2',
        FiscalIII: 'Quý 3',
        FiscalIV: 'Quý 4',

        Yesterday: 'Hôm qua',
        LastWeek: 'Tuần trước',
        LastMonth: 'Tháng trước',
        LastQuarter: 'Quý trước',
        LastYear: 'Năm trước',

        Tomorrow: 'Ngày mai',
        NextWeek: 'Tuần sau',
        NextMonth: 'Tháng sau',
        NextQuarter: 'Quý sau',
        NextYear: 'Năm sau',
        Custom: 'Tùy chọn',
        Last7Day: '7 ngày gần nhất',
        Other: 'Tùy chọn'
    },

    PeriodMax30Days: {
        ThisDay: 'Hôm nay',
        ThisWeek: 'Tuần này',
        FirstWeekToPresent: 'Đầu tuần tới hiện tại',
        ThisMonth: 'Tháng này',
        Last30Days: '30 ngày gần nhất',
        FirstMonthToPresent: 'Đầu tháng đến hiện tại',
        January: 'Tháng 1',
        February: 'Tháng 2',
        March: 'Tháng 3',
        April: 'Tháng 4',
        May: 'Tháng 5',
        June: 'Tháng 6',
        July: 'Tháng 7',
        August: 'Tháng 8',
        September: 'Tháng 9',
        October: 'Tháng 10',
        November: 'Tháng 11',
        December: 'Tháng 12',
        Yesterday: 'Hôm qua',
        LastWeek: 'Tuần trước',
        LastMonth: 'Tháng trước',
        Custom: 'Tùy chọn',
    },

    FormState: {
        /**
         * Mode View
         */
        View: 'Xem',
        /**
         * Thêm
         */
        Add: 'Thêm',
        /**
         * Sửa
         */
        Edit: 'Sửa',
        /**
         * Nhân bản
         */
        Duplicate: 'Nhân bản',
        /**
         * Thêm nhanh
         */
        QuickAdd: 'Thêm nhanh'
    },
    systemImport: {
        MisaService: 'MISA SME.NET - Dịch vụ',
        MisaMerchandise: 'MISA SME.NET - Hàng hóa',
        SME2012Service: 'MISA SME.NET 2012 - Dịch vụ',
        SME2012PayMerchandise: 'MISA SME.NET 2012 - Hàng hóa (Thanh toán ngay)',
        SME2012NotPayMerchandise: 'MISA SME.NET 2012 - Hàng hóa (Chưa thanh toán)',
        /// <summary>
        /// Fast dịch vụ
        /// </summary>
        FastService: 'FAST - Dịch vụ',
        /// <summary>
        /// Fast hàng hóa
        /// </summary>
        FastMerchandise: 'FAST - Hàng hóa'
        // /// <summary>
        // /// SmartPro dịch vụ
        // /// </summary>
        // SmartProService : 'SmartPro - Dịch vụ',
        // /// <summary>
        // /// SmartPro hàng hóa
        // /// </summary>
        // SmartProMerchandise : 'SmartPro - Hàng hóa',
        /// <summary>
        /// Easybook dịch vụ
        /// </summary>
        // EasybookService :  'Easybook - Dịch vụ',
        // /// <summary>
        // /// Easybook hàng hóa
        // /// </summary>
        // EasybookMerchandise :  'Easybook - Hàng hóa',
        // /// <summary>
        // /// Mẫu SAP
        // /// </summary>
        // TemplateSAP : 'Template SAP',
    },
    DeclarationExportAccounting: {
        MisaSmeMerchandise: 'MISA SME.NET - Hàng hóa'
    },
    //Mẫu xuất khẩu cần mua thêm mới được sử dụng
    newInvoiceExport: {
        /// <summary>
        /// Hóa đơn dịch vụ của MOKA
        /// </summary>
        InvoiceServiceMOKA: 'MOKA - Hóa đơn mua dịch vụ',
        /// <summary>
        /// HĐ mua hàng của MOKA
        /// </summary>
        InvoiceSaleMOKA: 'MOKA - Hóa đơn mua hàng trong nước',
        /// <summary>
        /// Phiếu chi của MOKA
        /// </summary>
        InvoiceMOKA: 'MOKA - Phiếu chi tiền mặt'
    },
    invoicesMassan: {
        /// <summary>
        /// Bảng kê HHDV mua vào của Massan
        /// </summary>
        InvoiceMassan: 'MASAN - Bảng kê hóa đơn chứng từ hàng hóa, dịch vụ mua vào'
    },
    outInvoiceExport: {
        InvoiceSaleAmis: 'MISA AMIS Kế toán - Hàng hóa',
        ServiceAmis: 'MISA AMIS Kế toán - Dịch vụ',
        InvoiceListAmis: 'MISA AMIS Kế toán - Danh sách hóa đơn',
        SMEInvoiceSale: 'MISA SME - Hóa đơn bán hàng',
        SMESale: 'MISA SME - Bán hàng'
    },
    lstImportVal: {
        InputInvoice: 'Danh sách hóa đơn đầu vào'
    },
    lstImportOutInvoiceVal: {
        OutInvoiceList: 'Danh sách hóa đơn đầu ra'
    },
    lstInvoiceStatement: {
        ListInvoiceBuyer: 'Bảng kê hóa đơn hàng hóa, dịch vụ mua vào (tổng hợp)',
        InvoiceBuyer: 'Bảng kê hóa đơn hàng hóa, dịch vụ mua vào (chi tiết)'
    },
    DeclarationExport: {
        DeclarationList: 'Danh sách tờ khai',
        DeclarationDetail: 'Chi tiết tờ khai'
    },
    InvoiceReportList: {
        ListInvoiceBuyer802021: 'Bảng kê mua vào theo mẫu số 01-1/HT (Thông tư số 80/2021/TT-BTC)'
    },
    listImport: {
        InvoiceList: 'Danh sách hóa đơn đầu vào',
        ExportToOtherApp: 'Nhập khẩu vào phần mềm kế toán'
    },
    /**
     * Text loại phương thức thanh toán
     */
    PaymentMethod: {
        Admin: 1,
        User: 2,
        ATM: 'Thẻ ATM',
        Visa: 'Thẻ tín dụng',
        PaymentProvider: 'Ví điện tử',
        Tranfers: 'Chuyển khoản',
        Paypal: 'Paypal',
        Jetpay: 'Jetpay'
    },
    PaymentStatus: {
        /// Chưa thanh toán
        New: 'Chưa thanh toán',
        /// Chờ xác nhận thanh toán
        WaitPaymentConfirm: 'Chờ xác nhận thanh toán',
        /// Đã gửi xác nhận thanh toán
        SentPaymentConfirm: 'Đã gửi xác nhận thanh toán',
        /// Đã thanh toán
        Paid: 'Đã thanh toán',
        /// Đã hủy
        CancelPayment: 'Đã hủy đơn hàng'
    },
    FileType: {
        All: 'Tất cả',
        Xml: 'XML',
        Pdf: 'PDF',
        Image: 'Ảnh'
    },
    InvoiceTemplate: {
        TaxRate: 'Một thuế suất',
        ManyTaxRate: 'Nhiều thuế suất'
    },
    VatRate: {
        KHAC: 'KHAC',
        KKKNT: 'KKKNT',
        KCT: 'KCT',
        KTPVDC: 'KTPVDC',
        KTGTT: 'KTGTT',
        Rate0: '0%',
        Rate5: '5%',
        Rate8: '8%',
        Rate10: '10%'
    },
    AuditingLogActionType: {
        /// Chưa xác định
        None: 'Chưa xác định',
        /// Upload hóa đơn
        Upload: 'Upload hóa đơn',
        /// Xóa hóa đơn
        DeleteInvoice: 'Xóa hóa đơn',
        /// Khôi phục hóa đơn
        RestoreInvoice: 'Khôi phục Hóa đơn đã xóa',
        /// Chấp nhận tên địa chỉ hóa dơn
        InvoiceAccept: 'Chấp nhận Tên/địa chỉ/mã số thuế',
        /// Cập nhật mã NCC
        UpdateSupplierCode: 'Cập nhật nhà cung cấp/khách hàng',
        /// Dán nhãn
        InvoiceStick: 'Gắn nhãn dán',
        /// Đính kèm tệp vào hóa đơn
        InvoiceAttachFile: 'Thêm tệp đính kèm',
        /// Ghi chú trên hóa đơn
        InvoiceDescription: 'Ghi chú',
        /// Chi nhánh phòng ban
        UpdateCompany: 'Sửa cơ cấu tổ chức',
        /// Xóa
        DeleteEmail: 'Xóa email',
        /// Khôi phục email
        RestoreEmail: 'Khôi phục email',
        /// Xóa vĩnh viễn
        DeleteForeverEmail: 'Xóa vĩnh viễn',
        /// Xóa file đính kèm
        InvoiceAttachFileRemove: 'Xóa tệp đính kèm',
        /// Thêm chi nhánh phòng ban
        AddCompany: 'Thêm cơ cấu tổ chức',
        /// Xóa chi nhánh phòng ban
        DeleteCompany: 'Xóa cơ cấu tổ chức',
        /// Xóa dán nhãn
        DeleteInvoiceStick: 'Xóa nhãn dán',
        /// Đã hạch toán
        Accounted: 'Đánh dấu Đã hạch toán',
        /// Chưa hạch toán
        UnAccounted: 'Đánh dấu Chưa hạch toán',
        /// Upload lại hóa đơn pdf
        ReUploadInvoicePdf: 'Cập nhật tệp hóa đơn PDF',
        /// Upload lại ảnh
        ReUploadInvoiceImg: 'Cập nhật tệp hóa đơn ảnh',
        /// Sửa người dùng
        UpdateRoleUser: 'Sửa người dùng',
        //Điều chuyển
        MoveInvoice: 'Điều chuyển hóa đơn đầu vào',
        /// Chấp nhận chữ ký số hợp lệ
        AcceptSellerSignature: 'Chấp nhận chữ ký số NCC hợp lệ',
        /// Chấp nhận hoạt động người bán hợp lệ
        AcceptSellerActiveStatus: 'Chấp nhận hoạt động người bán hợp lệ',
        /// Chấp nhận rủi ro người bán hợp lệ
        AcceptTaxRiskStatus: 'Chấp nhận rủi ro người bán hợp lệ',
        /// Đăng nhập kết nối nhà cung cấp HĐ
        ConnectInvoiceLogin: 'Kết nối tự động lấy Hóa đơn từ NCC',
        /// Hủy kết nối HĐ
        ConnectInvoiceLogout: 'Hủy kết nối tự động lấy Hóa đơn từ NCC',
        /// Sửa HĐ nhập tay
        EditHandEntered: 'Sửa hóa đơn nhập tay',
        ///Đăng nhập kết nối dữ liệu CQT
        ConnectTaxaxionLogin: 'Thiết lập kết nối tự động tài khoản CQT',
        ///Hủy kết nối dữ liệu CQT
        ConnectTaxaxionLogout: 'Hủy kết nối dữ liệu Cơ quan thuế',
        ///Đồng bộ dữ liệu ncc
        ConnectInvoiceSync: 'Đồng bộ dữ liệu kết nối NCC',
        ///Đồng bộ dữ liệu cơ quan thuế
        ConnectTaxaxionSync: 'Đồng bộ dữ liệu Cơ quan thuế',
        ///Kiểm tra thuế suất NQ43
        CheckingVat: 'Kiểm tra thuế suất',
        ///Kiểm tra lại email
        CheckAgainEmail: 'Kiểm tra lại email',
        ///Tải lại hóa đơn của cqt
        RefreshInvoiceTaxaxion: 'Tải lại dữ liệu CQT',
        //Thiết lập tên file tải xuống
        SettingSystemDownload: 'Thiết lập tên file tải xuống',
        // Thiệt lập nhắc hạn thanh toán
        SettingSystemPayment: 'Thiết lập nhắc hạn thanh toán',
        // Đánh dấu thanh toán hóa đơn
        PaymentInvoice: 'Đánh dấu thanh toán',
        /// Đánh dấu thanh toán
        AcceptPayment: 'Đánh dấu thanh toán',
        //Gắn nhãn hàng loạt
        InvoiceSticks: 'Gắn nhãn hàng loạt',
        /// Bỏ nhãn dán
        RemoveStick: 'Bỏ nhãn dán',
        //Gắn nhãn và bỏ nhãn
        RemoveAndAttachStick: 'Gắn nhãn/Bỏ gắn nhãn',
        /// Thêm/xóa nhãn dán
        InsertDeleteStick: 'Thêm nhãn/Xóa nhãn',
        /// Sửa nhãn dán
        UpdateStick: 'Sửa nhãn',
        /// Lưu và kiểm tra hóa đơn nhập tay
        HandEntered: 'Kiểm tra hóa đơn nhập tay',
        //Lưu nháp hóa đơn nhập tay
        SaveDraft: 'Lưu nháp',
        // Thêm người dùng
        AddUser: 'Thêm người dùng',
        // Xóa người dùng
        DeleteUser: 'Xóa người dùng',
        // Thêm mới chức danh
        AddJobTitle: 'Thêm chức danh',
        // Thêm mới vai trò quyền hạn
        AddRolePermission: 'Thêm vai trò quyền hạn',
        // Xóa vai trò quyền hạn
        DeleteRolePermission: 'Xóa vai trò quyền hạn',
        // Sửa vai trò quyền hạn
        EditRolePermission: 'Sửa vai trò quyền hạn',
        DeleteOutInvoice: 'Xóa hóa đơn đầu ra',
        RestoreOutInvoice: 'Khôi phục hóa đơn đầu ra',
        MoveOutInvoice: 'Điều chuyển hóa đơn đầu ra',
        ConnectDownloadMeInvoice: 'Thiết lập Tự động tải Hóa đơn đầu ra của MISA meInvoice',
        UnConnectDownloadMeInvoice: 'Bỏ thiết lập Tự động tải Hóa đơn đầu ra của MISA meInvoice',
        /// <summary>
        /// Kết nối lại CQT
        /// </summary>
        ConnectAgainTaxaxion: 'Kết nối lại TK ',
        UnConnectTaxaxion: 'Ngắt kết nối',
        /// <summary>
        /// Kết nối tài khoỏa
        /// </summary>
        ConnectTaxaxionInvoice: 'Kết nối tài khoản CQT',
        AcceptExistTCT: 'Chấp nhận Hóa đơn tồn tại hợp lệ trên hệ thống CQT',
        /// <summary>
        /// Kiểm tra lại hóa đơn đang kiểm tra
        /// </summary>
        CheckAgianV2: 'Kiểm tra lại Hóa đơn đầu vào',
        /// <summary>
        /// Kiểm tra lại tờ khai
        /// </summary>
        DeclarationCheckAgain: 'Kiểm tra lại Tờ khai hải quan',
        /// <summary>
        /// Đánh dấu email chưa đọc
        /// </summary>
        UnRead: 'Đánh dấu thư chưa đọc',
        RemoveSticks: 'Bỏ gắn nhãn',
        //Gắn nhãn
        AttachStick: 'Gắn nhãn',
        /// <summary>
        /// Thiệt lập tự động điêu chuyển
        /// </summary>
        SettingTransformOrg: 'Thiết lập tự động điều chuyển hóa đơn cho chi nhánh/phòng ban',
        /// <summary>
        /// Thêm chi nhánh thiết lập tự động điều chuyển hđ
        /// </summary>
        InsertTransformOrg: 'Thêm thiết lập tự động điều chuyển Hóa đơn cho chi nhánh/phòng ban',
        /// <summary>
        /// Sửa chi nhánh thiết lập tự động điều chuyển hđ
        /// </summary>
        EditTransformOrg: 'Sửa thiết lập tự động điều chuyển Hóa đơn cho chi nhánh/phòng ban',
        /// <summary>
        /// Xóa chi nhánh thiết lập tự động điều chuyển hđ
        /// </summary>
        DeleteTransformOrg: 'Xóa thiết lập tự động điều chuyển Hóa đơn cho chi nhánh/phòng ban',
        /// <summary>
        /// Thêm mới NCC
        /// </summary>
        InsertSupplier: 'Thêm mới NCC',
        ///Kiểm tra lại hàng loạt email
        CheckAgainMultiEmail: 'Kiểm tra lại email',
        /// <summary>
        /// Thiết lập không tự động tải hóa đơn
        /// </summary>
        SettingNoDownloadInvoice: 'Thay đổi chọn thiết lập tải về hóa đơn theo từng nhà cung cấp',
        /// <summary>
        /// Bỏ thiết lập tự động điêu chuyển
        /// </summary>
        UnSettingTransformOrg: 'Bỏ thiết lập tự động điều chuyển hóa đơn cho chi nhánh/phòng ban',
        /// <summary>
        /// Thêm thiết lập không tải hóa đơn NCC
        /// </summary>
        InsertSupNoDownInv: 'Thêm thiết lập bỏ qua một số nhà cung cấp khi tải hóa đơn cho chi nhánh/phòng ban',
        /// <summary>
        /// Xóa thiết lập không tải hóa đơn NCC
        /// </summary>
        DeleteSupNoDownInv: 'Xóa thiết lập bỏ qua một số nhà cung cấp khi tải hóa đơn cho chi nhánh/phòng ban',
        /// <summary>
        /// Thêm thiết lập chỉ tải hóa đơn NCC
        /// </summary>
        InsertSupOnlyDownInv: 'Thêm thiết lập chỉ tải hóa đơn của các nhà cung cấp được chọn cho chi nhánh/phòng ban',

        ChooseSupplierOnlyOrSupplierNoDownloadInv: 'Thay đổi chọn thiết lập tải về hóa đơn theo từng nhà cung cấp',
        /// <summary>
        /// Xóa thiết lập chỉ tải hóa đơn NCC
        /// </summary>
        DeleteSupOnlyDownInv: 'Xóa thiết lập chỉ tải hóa đơn của các nhà cung cấp được chọn cho chi nhánh/phòng ban',
        /// <summary>
        /// Chấp nhận chữ ký số CQT hợp lệ
        /// </summary>
        AcceptTaxaxionSignature: 'Chấp nhận chữ ký số CQT hợp lệ',
        /// <summary>
        /// Tải lại hóa đơn NCC
        /// </summary>
        RefreshInvoice: 'Tải lại dữ liệu NCC',
        /// <summary>
        /// Upload hóa đơn đầu ra
        /// </summary>
        UploadOutInvoice: 'Upload Hóa đơn - đầu ra',
        /// <summary>
        /// Thiết lập tự động điều chuyển hóa đơn cho chi nhánh/phòng ban(phân loại hóa đơn theo MST)
        /// </summary>
        SettingTransferInvByTaxCode: 'Thiết lập điều chuyển hóa đơn từ nguồn email',
        /// <summary>
        /// Thiết lập tự động điều chuyển hóa đơn cho chi nhánh/phòng ban(phân loại hóa đơn theo MST)
        /// </summary>
        UnSettingTransferInvByTaxCode: 'Bỏ thiết lập điều chuyển hóa đơn từ nguồn email',
        /// <summary>
        /// Thêm điều chuyển hóa đơn cho chi nhánh/phòng ban(theo MST)
        /// </summary>
        AddTransferInvByTaxCode: 'Thêm thiết lập điều chuyển hóa đơn từ nguồn email',
        /// <summary>
        /// Sửa điều chuyển hóa đơn cho chi nhánh/phòng ban(theo MST)
        /// </summary>
        UpdateTransferInvByTaxCode: 'Sửa thiết lập điều chuyển hóa đơn từ nguồn email',
        /// <summary>
        /// Xóa điều chuyển hóa đơn cho chi nhánh/phòng ban(theo MST)
        /// </summary>
        DeleteTransferInvByTaxCode: 'Xóa thiết lập điều chuyển hóa đơn từ nguồn email',
        DownloadInvoiceWithoutCode: 'Thiết lập tự động tải về hóa đơn không mã gửi theo hình thức bảng tổng hợp',
        DownloadOutInvoiceWithoutCode: 'Thiết lập tự động tải về hóa đơn không mã gửi theo hình thức bảng tổng hợp',
        UnDownloadInvoiceWithoutCode: 'Bỏ thiết lập tự động tải về hóa đơn không mã gửi theo hình thức bảng tổng hợp',
        UnDownloadOutInvoiceWithoutCode: 'Bỏ thiết lập tự động tải về hóa đơn không mã gửi theo hình thức bảng tổng hợp',
        ConnectAgainSupplier: 'Kết nối lại TK ',
        UploadFileXML: 'Cập nhật tệp hóa đơn XML',
        /// <summary>
        /// Thiết lập  chọn loại hóa đơn tải về khác từ CQT đầu vào
        /// </summary>
        SelectOtherDownloadInvoiceInbot: 'Thiết lập chọn loại hóa đơn đầu vào tải về từ nguồn CQT',
        /// <summary>
        ///  Bỏ thiết lập  chọn loại hóa đơn tải về khác từ CQT đầu vào
        /// </summary>
        UnSelectOtherDownloadInvoiceInbot: 'Thiết lập chọn loại hóa đơn đầu vào tải về từ nguồn CQT',
        /// <summary>
        /// Thiết lập  chọn loại hóa đơn tải về khác từ CQT đầu ra
        /// </summary>
        SelectOtherDownloadInvoiceOutInbot: 'Thiết lập chọn loại hóa đơn đầu ra tải về từ nguồn CQT',
        /// <summary>
        /// Bỏ thiết lập  chọn loại hóa đơn tải về khác từ CQT đầu ra
        /// </summary>
        UnSelectOtherDownloadInvoiceOutInbot: 'Thiết lập chọn loại hóa đơn đầu ra tải về từ nguồn CQT',
        /// <summary>
        /// Thiết lập loại hóa đơn đầu vào tải về từ nguồn CQT
        /// </summary>
        SettingTypeDownloadInvoiceInbot: 'Thiết lập loại hóa đơn đầu vào tải về từ nguồn CQT',
        /// <summary>
        /// Thiết lập loại hóa đơn đầu ra tải về từ nguồn CQT
        /// </summary>
        SettingTypeDownloadInvoiceOutbot: 'Thiết lập loại hóa đơn đầu ra tải về từ nguồn CQT',
        AcceptCheckTax: 'Chấp nhận thuế suất theo Nghị quyết giảm thuế',
        UnPaymentInvoice: 'Bỏ đánh dấu thanh toán',
        SettingSystemIgnoreExistTax: 'Thiết lập danh sách mẫu số, ký hiệu chấp nhận tồn tại trên CQT',
        SettingSystemCriteriaVerification: 'Thiết lập tiêu chí kiểm tra trên hóa đơn',
        SettingAbbreviationSetup: 'Thiết lập kiểm tra tên, địa chỉ người mua/người bán',
        ActionSupplierAcceptTaxAuthority: 'Thiết lập Không kiểm tra tồn tại trên Cơ quan thuế',
        ActionEmailReceiveAlert: 'Thiết lập cảnh báo qua email khi có KH/NCC thay đổi tình trạng hoạt động',
        SettingActionEmailReceiveAlert: 'Thiết lập cảnh báo qua email khi có KH/NCC thay đổi tình trạng hoạt động',
        RemovePdf: 'Xóa bản thể hiện',
        SettingRemind: 'Thiết lập nhắc nhở',
        TaxaxionSyncByTool: 'Đồng bộ dữ liệu Cơ quan thuế bằng công cụ',
        UpdatePdfInvoice: 'Bổ sung bản thể hiện của hóa đơn',
        UpdatePdfFromEmail: 'Bổ sung bản thể hiện của hóa đơn',
        UpdatePdfFromSearch: 'Cập nhật bản thể hiện của hoá đơn',
        AutoDownloadPdf: 'Bổ sung bản thể hiện của hóa đơn',
        AutoDownloadXml: 'Bổ sung xml của hóa đơn',
        SettingTemplate: 'Thiết lập mẫu hóa đơn',
        UploadFilePdf: 'Tải lên bản thể hiện của hóa đơn',
        UploadDeclaration: 'Upload tờ khai',
        /// <summary>
        /// Chấp nhận đơn vị tính
        /// </summary>
        AcceptedUnitName: 'Chấp nhận Đơn vị tính hợp lệ',
        /// <summary>
        /// Chấp nhận số lượng
        /// </summary>
        AcceptedQuantity: 'Chấp nhận thông tin Số lượng hợp lệ',
        /// <summary>
        /// Chấp nhận đơn giá
        /// </summary>
        AcceptedUnitPrice: 'Chấp nhận thông tin Đơn giá hợp lệ',
        /// <summary>
        /// Xóa thông tin HHDV trong lịch sử chấp nhận thuế suất
        /// </summary>
        DeleteItemVatRate: 'Bạn muốn xóa hàng hóa, dịch vụ',
        /// <summary>
        /// Sửa thông tin lịch sử chấp nhận thuế suất
        /// </summary>
        EditHistoryVatRate: 'Sửa chấp nhận thuế suất của hàng hóa, dịch vụ',
        SpamEmail: 'Báo cáo email spam',
        NotSpamEmail: 'Đánh dấu email không phải spam',
        UserSetup: 'Thiết lập người dùng',
        ClassificationCost: 'Phân loại hóa đơn',
        ClassificationCostMany: 'Phân loại hóa đơn hàng loạt',
        SettingClassificationInvoice: 'Thiết lập tự động phân loại hóa đơn',
        SettingCostNorms: 'Thiết lập định mức chi phí',
        AcceptExchangeRate: 'Chấp nhận thông tin Tỷ giá hợp lệ',
        SyntheticVatRate: 'Chấp nhận thông tin tổng hợp theo mức thuế suất hợp lệ',
        SettingCostType: 'Thiết lập định mức chi phí',
        UpdateInvoiceCostType: 'Cập nhật định mức chi phí',
        UpdateInvoiceCostTypeMany: 'Cập nhật định mức chi phí hàng loạt',
        DeleteDeclaration: 'Xóa tờ khai',
        RestoreDeclaration: 'Khôi phục tờ khai',
        MoveOnDeclaration: 'Điều chuyển tờ khai',
        RestoreInvoices: 'Khôi phục hàng loạt hóa đơn đầu vào',
        RestoreOutInvoices: 'Khôi phục hàng loạt hóa đơn đầu ra',
        AcceptMultiResult: 'Chấp nhận hợp lệ',
        UpdateInvoiceEmailReceive: 'Thay đổi địa chỉ email nhận hóa đơn',
        UpdateFilterInvoiceList: 'Thiết lập mặc định lọc ngày trên danh sách hóa đơn đầu vào',
        SaveCriteriaSetup: 'Lưu thiết lập tiêu chí kiểm tra hóa đơn',
        SaveAbbreviationSetup: 'Thiết lập kiểm tra tên, địa chỉ người mua/người bán',
        CharacteristicGoods: 'Chấp nhận hàng hóa đặc trưng',
        AcceptCheckLogic: 'Chấp nhận chính xác về tính toán số liệu',
        CompareTotalAmountInWordsAndNumbers: 'Chấp nhận lệch tổng tiền bằng chữ với tổng tiền bằng số',
        ChangeIdentificationNumberOrganizationChange: 'Tự động xóa thiết lập tự động điều chuyển hóa đơn từ nguồn email',
        /// Bỏ Chấp nhận tên địa chỉ hóa dơn
        InvoiceUnAccept: 'Bỏ chấp nhận Tên/địa chỉ/mã số thuế',
        AcceptInvoiceName: 'Chấp nhận tên hóa đơn',
        UnacceptInvoiceName: 'Bỏ chấp nhận tên hóa đơn',
        SettingAmountBeforeDiscountSetup: 'Thiết lập công thức tính toán số liệu Thành tiền chưa trừ chiết khấu',
        AcceptBusinessLocation: 'Chấp nhận thiếu thông tin địa điểm kinh doanh',
        DeleteDeclarationBatch: 'Xóa hàng loạt tờ khai hải quan',
        CheckAgainOutInvoice: 'Kiểm tra lại Hóa đơn đầu ra',
        SettingShowInvoiceLoadingList: 'Thay đổi thiết lập hiển thị danh sách hóa đơn đang tải',
        ReloadPendingInvoice: 'Tải lại hóa đơn đang tải',
        ReloadPendingOutInvoice: 'Tải lại hóa đơn đầu ra đang tải'
    },
    KindAccountingDate: {
        All: 'Tất cả',
        Accounted: 'Đã hạch toán',
        NotAccounted: 'Chưa hạch toán'
    },
    AttachStatus: {
        All: 'Tất cả',
        HasAttachFile: 'Có tệp đính kèm',
        NotHasAttachFile: 'Không có tệp đính kèm'
    },
    StatusView: {
        All: 'Tất cả',
        Viewed: 'Đã xem',
        UnViewed: 'Chưa xem'
    },
    InvoiceEmailStatus: {
        All: 'Tất cả',
        InvoiceValid: 'Hóa đơn hợp lệ',
        EmailInvalid: 'Email không hợp lệ',
        MaxAttachmentSize: 'Dung lượng email vượt quá 10MB',
        InvoiceInvalid: 'Hóa đơn không hợp lệ',
        InvoiceDuplicate: 'Hóa đơn trùng',
        InvoiceNoRead: 'Không đọc được hóa đơn',
        Draft: 'Bản nháp',
        Checking: 'Đang kiểm tra',
        Expired: 'Hết hạn sử dụng',
        InvoiceDetele: 'Hóa đơn xóa bỏ',
        InvoiceNotNeedCheck: 'Hóa đơn NCC nước ngoài'
    },
    TypeInvoiceReceive: {
        All: 'Tất cả',
        Upload: 'Tải lên',
        Email: 'Email',
        Auto: 'Tự động tải về',
        HandInput: 'Nhập tay'
    },
    DateFilterType: {
        InvoiceDate: 'Hóa đơn',
        AccountingDate: 'Hạch toán',
        ReceivedDate: 'Vào hệ thống',
        PaymentWarning: 'Nhắc hạn thanh toán',
        PaymentOutOfDate: 'Quá hạn thanh toán',
        PaymentNotPay: 'Chưa thanh toán',
        ChangeStatusInvoiceDate: 'Thay đổi trạng thái trên CQT',
        ChangeStatusInvoiceOnSystemDate: 'Phát hiện thay đổi trạng thái',
        DeclarationDate: 'Ngày tờ khai'
    },
    ReasonType: {
        ProductNotGood: 'Sản phẩm không đáp ứng nhu cầu',
        ProductError: 'Sản phẩm hay bị lỗi',
        SupportServiceNotGood: 'Dịch vụ tư vấn hỗ trợ khách hàng kém',
        HighPrice: 'Giá thành cao',
        UseConvenient: 'Thao tác sử dụng không thuận tiện',
        SlowProcessingSpeed: 'Tốc độ xử lý chậm',
        SecurityNotGood: 'Bảo mật phần mềm kém',
        ReasonOther: 'Lý do khác'
    },
    TThaiHDonEnum: {
        Goc: 'Hóa đơn mới', // Hóa đơn gốc
        ThayThe: 'Hóa đơn thay thế', // Hóa đơn thay thế
        DieuChinh: 'Hóa đơn điều chỉnh', // Hóa đơn điều chỉnh
        DaThayThe: 'Hóa đơn đã bị thay thế', // Hóa đơn đã bị thay thế
        DaDieuChinh: 'Hóa đơn đã bị điều chỉnh', // Hóa đơn đã bị điều chỉnh
        Xoa: 'Hóa đơn đã bị hủy', // Hóa đơn đã bị xóa bỏ/hủy bỏ
        Unknown: 'Hóa đơn chưa xác định'
    },
    AmountPayment: {
        Nothing: '',
        /// <summary>
        /// Chưa thanh toán
        /// </summary>
        NotPair: 'Chưa thanh toán',
        /// <summary>
        /// Thanh toán toàn phần
        /// </summary>
        PairAll: 'Thanh toán toàn phần',
        /// <summary>
        /// Quá hạn thanh toán
        /// </summary>
        PairOutOfDate: 'Quá hạn thanh toán',
        /// <summary>
        /// Đến hạn thanh toán
        /// </summary>
        PairWarning: 'Đến hạn thanh toán',
        /// <summary>
        /// Thanh toán một phần
        /// </summary>
        PairPart: 'Thanh toán một phần'
    },
    ReadEmailStatus: {
        /// <summary>
        /// Tất cả
        /// </summary>
        All: 'Tất cả',
        /// <summary>
        /// Mail chưa đọc
        /// </summary>
        NotRead: 'Chưa đọc',
        /// <summary>
        /// Mail đã đọc
        /// </summary>
        Read: 'Đã đọc'
    },
    FileTypeDownloadInvoice: {
        All: 'Tất cả',
        Pdf: 'Chỉ bản thể hiện',
        Xml: 'Chỉ XML',
        Attachment: 'Chỉ tệp đính kèm',
        PdfAndXml: 'Bản thể hiện và XML'
    },
    ActiveStatus: {
        All: 'Tất cả',
        Active: 'Đang hoạt động',
        Inactive: 'Ngừng hoạt động',
        WaitingUpdateIdentityCode: 'Chờ cập nhật CCCD',
        WaitingVerification: 'Chờ xác minh',
        NotSure: 'Chưa xác định'
    },
    ReportInvoiceStatus: {
        All: 'Tất cả',
        Adjust: 'Điều chỉnh',
        Replace: 'Thay thế'
    },
    ConntectTaxaxionStatus: {
        Today: 'Hôm nay',
        ThisWeek: 'Tuần này',
        SevenDay: '7 ngày',
        Last30Day: '30 ngày gần nhất'
    },
    StatusStick: {
        All: 'Tất cả',
        InvoiceOriginal: 'HĐ mới',
        InvoiceReplace: 'HĐ thay thế',
        InvoiceAdjust: 'HĐ điều chỉnh',
        InvoiceReplaced: 'HĐ đã bị thay thế',
        InvoiceAdjusted: 'HĐ đã bị điều chỉnh',
        InvoiceCancel: 'HĐ đã bị hủy',
        InvoiceUnknow: 'HĐ chưa xác định'
    },
    StatusStickReport: {
        All: 'Tất cả',
        InvoiceOriginal: 'HĐ mới',
        InvoiceReplace: 'HĐ thay thế',
        InvoiceAdjust: 'HĐ điều chỉnh',
        InvoiceReplaced: 'HĐ đã bị thay thế',
        InvoiceAdjusted: 'HĐ đã bị điều chỉnh',
        InvoiceUnknow: 'HĐ chưa xác định'
    },
    RiskStatusCombobox: {
        All: 'Tất cả',
        NoRisky: 'Không rủi ro',
        Risky: 'Rủi ro'
    },
    FilterOperator: {
        Contains: 'Chứa',
        NotContains: 'Không chứa',
        Equals: 'Bằng',
        NotEquals: 'Khác',
        StartWith: 'Bắt đầu với',
        EndWith: 'Kết thúc với',
        LessThan: 'Nhỏ hơn', //Nhỏ hơn
        LessThanOrEqual: 'Nhỏ hơn hoặc bằng', //Nhỏ hơn hoặc bằng
        GreaterThan: 'Lớn hơn', //Lớn hơn
        GreaterThanOrEqual: 'Lớn hơn hoặc bằng', //Lớn hơn hoặc bằng
        In: 'Chứa', //Trong
        NotIn: 'Không chứa', //Không trong
        Between: 'Trong khoảng', //Giữa khoảng
        Blank: '(Trống)',
        NotBlank: '(Không trống)',
        IsNull: '(Trống)',
        IsNotNull: '(Không trống)'
    },
    FilterMCQT: {
        All: 'Tất cả',
        IsNull: 'Trống',
        NotNull: 'Không trống'
    },
    /**
     * Bộ lọc trạng thái hóa đơn - Kết quả kiểm tra trên grid
     */
    InvoiceStatusFilter: {
        All: 'Tất cả',
        WaitChecking: 'Đang kiểm tra',
        Valid: 'Hợp lệ',
        Invalid: 'Không hợp lệ',
        NotNeedCheck: 'Không kiểm tra',
        InvalidBuyerInfo: 'Sai thông tin người mua',
        InvalidSellerInfo: 'Sai thông tin người bán',
        InvalidGeneralInfo: 'Sai thông tin chung',
        InvalidItems: 'Sai thông tin hàng hóa',
        InvalidPaymentInfo: 'Sai thông tin thanh toán',
        InvalidSignInfo: 'Sai thông tin chữ ký số',
        CheckWidthTCT: 'Kiểm tra với hệ thống Cơ quan Thuế',
        InvalidInvoiceInstead: 'Sai thông tin hóa đơn bị thay thế',
        InvalidInvoiceAdjust: 'Sai thông tin hóa đơn bị điều chỉnh'
    },
    /**
     * Bộ lọc tệp hóa đơn
     */
    InvoiceFileFilter: {
        All: 'Tất cả',
        NoPdf: 'Không bản thể hiện',
        HasPdf: 'Có bản thể hiện',
        NoXml: 'Không xml',
        HasXml: 'Có xml',
        HasXmlNoPdf: 'Có xml - Không bản thể hiện',
        HasPdfNoXml: 'Có bản thể hiện - Không xml',
        HasXmlHasPdf: 'Có xml - Có bản thể hiện'
    },
    InvoiceHasPdfFilter: {
        All: 'Tất cả',
        NoPdf: 'Không bản thể hiện',
        HasPdf: 'Có bản thể hiện',
        HasXmlNoPdf: 'Không bản thể hiện - Có XML',
        HasPdfNoXml: 'Có bản thể hiện - Không XML',
        HasXmlHasPdf: 'Có bản thể hiện - Có XML'
    },
    InvoiceHasXmlFilter: {
        All: 'Tất cả',
        NoXml: 'Không XML',
        HasXml: 'Có XML',
        HasXmlNoPdf: 'Có XML - Không bản thể hiện',
        HasPdfNoXml: 'Không XML - Có bản thể hiện',
        HasXmlHasPdf: 'Có XML - Có bản thể hiện'
    },
    /**
     * Enum thể hiện trạng thái kiểm tra thuế suất gán vào combobox
     */
    CheckingVatStatusFlagsFilter: {
        All: 'Tất cả',
        None: 'Trống',
        Exact: 'Thuế suất chính xác',
        UnExact: 'Thuế suất chưa chính xác',
        Checking: 'Đang kiểm tra',
        ErrorCheckingVat: 'Thuế suất 8% ngoài thời gian giảm thuế',
        Accept: 'Thuế suất được chấp nhận'
    },
    AmountPaymentFilter: {
        All: 'Tất cả',
        Nothing: 'Bỏ trống',
        NotPair: 'Chưa thanh toán',
        PairAll: 'Thanh toán toàn phần',
        PairOutOfDate: 'Quá hạn thanh toán',
        PairWarning: 'Đến hạn thanh toán',
        PairPart: 'Thanh toán một phần'
    },

    CostTypeEnumGrid: {
        //Tất cả
        All: 'Tất cả',
        /// <summary>
        /// Điện
        /// </summary>
        Electricity: 'Điện',
        /// <summary>
        /// Nước
        /// </summary>
        Water: 'Nước',
        /// <summary>
        /// Viễn thông
        /// </summary>
        Telecommunication: 'Viễn thông',
        /// <summary>
        /// Bưu phí
        /// </summary>
        Postage: 'Bưu phí',
        /// <summary>
        /// Chi phí tài chính
        /// </summary>
        FinancialExpenses: 'Chi phí tài chính',
        /// <summary>
        /// Đường bộ
        /// </summary>
        RoadFees: 'Đường bộ',
        /// <summary>
        /// Bảo hiểm
        /// </summary>
        Insurance: 'Bảo hiểm',
        /// <summary>
        /// Thuê mặt bằng
        /// </summary>
        Rent: 'Thuê mặt bằng',
        /// <summary>
        /// Xăng, dầu
        /// </summary>
        Petroleum: 'Xăng, dầu',
        /// <summary>
        /// Tiếp khách
        /// </summary>
        ReceivingGuests: 'Tiếp khách',
        /// <summary>
        /// Lưu trú
        /// </summary>
        Accommodation: 'Lưu trú',
        /// <summary>
        /// Tiếp thị, quảng cáo
        /// </summary>
        MarketingOrAdvertising: 'Tiếp thị, quảng cáo',
        /// <summary>
        /// Phí gửi xe
        /// </summary>
        ParkingFee: 'Phí gửi xe',
        None: 'Không phân loại'
    },

    CostTypeEnumFilter: {
        All: 'Tất cả',
        Electricity: 'Điện',
        Water: 'Nước',
        Telecommunication: 'Viễn thông',
        Postage: 'Bưu phí',
        FinancialExpenses: 'Chi phí tài chính',
        RoadFees: 'Phí đường bộ',
        Insurance: 'Bảo hiểm',
        Rent: 'Thuê mặt bằng',
        Petroleum: 'Xăng, dầu',
        ReceivingGuests: 'Tiếp khách',
        Accommodation: 'Lưu trú',
        MarketingOrAdvertising: 'Tiếp thị, quảng cáo',
        ParkingFee: 'Phí gửi xe'
    },

    YesNo: {
        All: 'Tất cả',
        Yes: 'Có',
        No: 'Không',
        Blank: 'Trống'
    },
    StatusDownloadInvoice: {
        All: 'Tất cả',
        TotalInvoiceifference: 'Chưa tải được', // chưa tải được hóa đơn
        TotalDownloadSuccess: 'Tải thành công', // tải thành công
        TotalDownloadFail: 'Tải thất bại', // tải thất bại
        TotalInvoiceProcessing: 'Đang tải', // đang tải
        TotalInvoiceIgnore: 'Bỏ qua', // bỏ qua
        TotalInvoiceSuccess: 'HĐ đã xử lý', // hóa đơn đang xử lý
        TotalInvoiceDuplicate: 'HĐ trùng' // hóa đơn trùng
    },
    DatePickerTypeSelect: {
        Month: 'Tháng',
        Quarter: 'Quý',
        Year: 'Năm'
    },
    CompareType: {
        /// <summary>
        /// So sánh với kỳ trước liền kề
        /// </summary>
        /// <example>
        /// Q3/2025 → Q2/2025
        /// Q1/2025 → Q4/2024
        /// </example>
        Previous: 'Kỳ trước',

        /// <summary>
        /// So sánh với cùng kỳ năm trước
        /// </summary>
        /// <example>
        /// Q3/2025 → Q3/2024
        /// Q1/2025 → Q1/2024
        /// </example>
        SameLastYear: 'Cùng kỳ của năm trước'
    },
    TypeInvoiceReport: {
        All: 'Tất cả các loại hóa đơn',
        OnlyVatInvoice: 'Chỉ hóa đơn GTGT'
    }
};